// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Tooltip } from '@mui/material';
import { type IconProps } from '@shared/ui-kit/components/app-icon';
import { IconButton } from '@shared/ui-kit/components/icon-button';
import { type FC, type MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

export interface DeleteButtonProps {
  onClick: VoidFunction | MouseEventHandler<HTMLButtonElement>;
  toolTipTitle?: string;
  'data-testid'?: string;
  color?: IconProps['color'];
  className?: string;
}

export const DeleteButton: FC<DeleteButtonProps> = ({
  onClick,
  toolTipTitle,
  'data-testid': testId = 'delete-button',
  color = 'inherit',
  className,
}) => {
  const { t } = useTranslation();

  const tooltip = toolTipTitle || t('common.delete', { ns: 'common' });

  return (
    <Tooltip title={tooltip} placement="top">
      <IconButton
        className={className}
        variant="icon"
        icon="Trashcan"
        color={color}
        data-testid={testId}
        onClick={onClick}
      />
    </Tooltip>
  );
};
